import { render, staticRenderFns } from "./retrospect-file.vue?vue&type=template&id=5f5b7ee0&scoped=true"
import script from "./retrospect-file.vue?vue&type=script&lang=js"
export * from "./retrospect-file.vue?vue&type=script&lang=js"
import style0 from "./retrospect-file.vue?vue&type=style&index=0&id=5f5b7ee0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5b7ee0",
  null
  
)

export default component.exports